import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import logo from '../../images/Logo.png';
import iconSearch from '../../images/icon-search.png';
import iconMenu from '../../images/icon-menu.png';
import introCertification from '../../images/introCertification.png';
import introReceipt from '../../images/introReceipt.png';
import introImgFragment from '../../images/introImgFragment.png';
import introBgText from '../../images/introBgText.png';
import introductionLogo from '../../images/introductionlogo.png';

function Company() {
  const handleNavigation =()=>{

  }
  return (
 	    <>
      <div className="spinner">
        {Array(12).fill(0).map((_, i) => (
          <div key={i} className="spinner-blade"></div>
        ))}
      </div>

      <form method="post">
        <input type="hidden" id="nowPage"/>
        <input type="hidden" id="categoryCode"/>        

			{/* 상단바 설정돼서 주석처리 */}
        {/* <div className="header-container">
          <img className="logo" onClick={() => handleNavigation('/')} src={logo} alt="logo"/>
          <div className="TebletPcGnb">
            <ul>
              <li onClick={() => handleNavigation('/')}>Home</li>
              <li onClick={() => handleNavigation('/Shop')}>Shop</li>
            </ul>
            <div className="g-searchInput-box">
              <input type="text" id="searchText_p"/>
              <button type="button" className="btnSearch">
                <img src={iconSearch} alt="search icon"/>
              </button>
            </div>
          </div>
          <div className="basket" onClick={() => handleNavigation('/Cart')}>
            <div className="count hide" id="cartQuantity"></div>
          </div>
        </div> */}

        <div className="MoblieGnb">
          <div className="hamburger">
            <img src={iconMenu} alt="hamburger menu icon"/>
          </div>
          <div className="side-menu" style={{display: "none"}}>
            <ul className="menuList">
              <li onClick={() => handleNavigation('/')}>Home</li>
              <li onClick={() => handleNavigation('/Shop')}>Shop</li>
            </ul>
            <div className="g-searchInput-box">
              <input type="text" id="searchText_m"/>
              <button type="button" className="btnSearch">
                <img src={iconSearch} alt="search icon"/>
              </button>
            </div>
          </div>
        </div>
      </form>
        <div id="companyIntroduction">
	<div className="g-container">
		<section className="intro">
			<div className="container">
				<div className="backgroundText">
					<img src={introBgText} alt="bg Text"/>
					<img src={introBgText} alt="bg Text"/>
				</div>
				<img className="titleLogo" src={introductionLogo} alt="logo"/>
				<p>키즈 명품 쇼핑은 럭스키즈! <br/>유럽 현지 부티끄의 실시간 재고 수량을 한눈에</p>
			</div>
		</section>

		<section className="first">
			<div className="container">
				
				<div className="flex-box">
					<div className="play">
					<img className="certification" src={introCertification} alt="Certification img"/>
						<div className="number">01</div>
						<h1>인보이스 / 수입 필증 / 결제 영수증<br/>유럽 현지 상품 매입처 공유 및 증빙</h1>
						<p>럭스키즈는 모든 상품들의 상품 매입처를 고객님들께 공유드립니다.</p>
					</div>
					<div className="img-cover">
						<img src={introReceipt} alt="Receipt img"/>
						<div className="img-info">＊결제영수증 / 수입필증은 별도로 동봉 문의 부탁드립니다.</div>
					</div>
				</div>
			</div>
		</section>
		<section className="second">
			<div className="container">
				<div className="text-box">
					<div className="number">02</div>
					<h1>다양한 키즈 브랜드, 국내 최고의 할인율</h1>
					<div className="info">
						<p>
							구찌 키즈 / 버버리 키즈 / 몽클레어 키즈 등 유명 브랜드와 더불어 현지의 다양한 로컬 브랜드들을 럭스키즈 고객님들께
							소개드립니다.
						</p>
					</div>
				</div>
				<img className='introImgFragment' src={introImgFragment} alt="image fragment"/>
			</div>
		</section>
		<section className="third">
			<div className="container">
				<div className="number">03</div>
				<p>최저가 판매가 가능한 상품만 선정하여 수입</p>
				<div className="brand-list">
						<div className="list">BALENCIAGA</div>
						<div className="list">BALMAIN</div>
						<div className="list">BURBERRY</div>
						<div className="list">C.P. COMPANY</div>
						<div className="list">CHLOE</div>
						<div className="list">DOLCE &amp; GABBANA</div>
						<div className="list">EMPORIO ARMANI</div>
						<div className="list">GIVENCHY</div>
						<div className="list">GUCCI</div>
						<div className="list">KENZO</div>
						<div className="list">LITTLE MARC JACOBS</div>
						<div className="list">MONCLER</div>
						<div className="list">MSGM</div>
						<div className="list">NEIL BARRETT</div>
						<div className="list">OFF-WHITE</div>
						<div className="list">STELLA MCCARTNEY</div>
						<div className="list">STONE ISLAND</div>
						<div className="list">VERSACE</div>
					</div>
				</div>
		</section>
		<footer>
			<div>
			<p className="footertext">market.antsnest</p>
				<div className="pc-footer">
					<div className="info">
						<div className="title">COMPANY</div>
						<div className="content">상호 : (주)아이브랜디 | 대표 : 오승현<br/>
						주소 : 서울시 강남구 도산대로 205 (논현동) 4층<br/>
						사업자등록번호 : 742-86-01469<br/>
						통신판매업신고 : 2020-서울강남-02930
						</div>
					</div>
					<div className="cs-center">
						<div className="title">CUSTOMER CENTER</div>
						<div className="content">Tel : 02.541.9282<br/>
						Fax : 02.541.9284<br/>
						Email : info@brandi.co.kr<br/>
						운영시간 : 평일 10:00 - 19:00 (주말/공휴일 휴무)
						</div>
					</div>
					<div className="sns">
						<div className="title">FOLLOW US</div>
						<div className="content">
							<a href="https://www.facebook.com/brandi.me" target="_blank">facebook</a><br/>
							<a href="https://www.instagram.com/brandi.me" target="_blank">instagram</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
	</div>
</div>
        </>
    );
}

export default Company;